export const EXTENSION_FORMAT_PNG: string = 'png';
export const EXTENSION_FORMAT_JPEG: string = 'jpeg';
export const EXTENSION_FORMAT_JPG: string = 'jpg';
export const EXTENSION_FORMAT_GIF: string = 'gif';
export const EXTENSION_FORMAT_BMP: string = 'bmp';
export const EXTENSION_FORMAT_WEBP: string = 'webp';
export const EXTENSION_FORMAT_WMF: string = 'wmf';
export const EXTENSION_FORMAT_EMF: string = 'emf';
export const EXTENSION_FORMAT_TIF: string = 'tif';
export const EXTENSION_FORMAT_TIFF: string = 'tiff';
export const EXTENSION_FORMAT_SVG: string = 'svg';
export const EXTENSION_FORMAT_ICO: string = 'ico';
export const EXTENSION_FORMAT_CSV: string = 'csv';
export const EXTENSION_FORMAT_HTML: string = 'html';
export const EXTENSION_FORMAT_HTM: string = 'htm';
export const EXTENSION_FORMAT_XML: string = 'xml';
export const EXTENSION_FORMAT_XHTML: string = 'xhtml';
export const EXTENSION_FORMAT_MHT: string = 'mht';
export const EXTENSION_FORMAT_MHTML: string = 'mhtml';
export const EXTENSION_FORMAT_TXT: string = 'txt';
export const EXTENSION_FORMAT_RTF: string = 'rtf';
export const EXTENSION_FORMAT_PDF: string = 'pdf';
export const EXTENSION_FORMAT_JSON: string = 'json';
export const EXTENSION_FORMAT_XLS: string = 'xls';
export const EXTENSION_FORMAT_XLT: string = 'xlt';
export const EXTENSION_FORMAT_XLA: string = 'xla';
export const EXTENSION_FORMAT_XLW: string = 'xlw';
export const EXTENSION_FORMAT_XLSX: string = 'xlsx';
export const EXTENSION_FORMAT_XLTX: string = 'xltx';
export const EXTENSION_FORMAT_XLSM: string = 'xlsm';
export const EXTENSION_FORMAT_XLSB: string = 'xlsb';
export const EXTENSION_FORMAT_XLTM: string = 'xltm';
export const EXTENSION_FORMAT_XLAM: string = 'xlam';
export const EXTENSION_FORMAT_DOC: string = 'doc';
export const EXTENSION_FORMAT_DOT: string = 'dot';
export const EXTENSION_FORMAT_DOTX: string = 'dotx';
export const EXTENSION_FORMAT_DOCX: string = 'docx';
export const EXTENSION_FORMAT_DOCM: string = 'docm';
export const EXTENSION_FORMAT_DOTM: string = 'dotm';
export const EXTENSION_FORMAT_WORD: string = 'word';
export const EXTENSION_FORMAT_W6W: string = 'w6w';
export const EXTENSION_FORMAT_PPT: string = 'ppt';
export const EXTENSION_FORMAT_PPTX: string = 'pptx';
export const EXTENSION_FORMAT_POT: string = 'pot';
export const EXTENSION_FORMAT_POTX: string = 'potx';
export const EXTENSION_FORMAT_PPS: string = 'pps';
export const EXTENSION_FORMAT_PPSX: string = 'ppsx';
export const EXTENSION_FORMAT_PPA: string = 'ppa';
export const EXTENSION_FORMAT_PPAM: string = 'ppam';
export const EXTENSION_FORMAT_PPTM: string = 'pptm';
export const EXTENSION_FORMAT_PPSM: string = 'ppsm';
export const EXTENSION_FORMAT_POTM: string = 'potm';
export const EXTENSION_FORMAT_MDB: string = 'mdb';
export const EXTENSION_FORMAT_ACCDA: string = 'accda';
export const EXTENSION_FORMAT_ACCDB: string = 'accdb';
export const EXTENSION_FORMAT_ACCDE: string = 'accde';
export const EXTENSION_FORMAT_ACCDR: string = 'accdr';
export const EXTENSION_FORMAT_ACCDT: string = 'accdt';
export const EXTENSION_FORMAT_ADE: string = 'ade';
export const EXTENSION_FORMAT_ADP: string = 'adp';
export const EXTENSION_FORMAT_ADN: string = 'adn';
export const EXTENSION_FORMAT_MDE: string = 'mde';
export const EXTENSION_FORMAT_MDF: string = 'mdf';
export const EXTENSION_FORMAT_MDN: string = 'mdn';
export const EXTENSION_FORMAT_MDT: string = 'mdt';
export const EXTENSION_FORMAT_MDW: string = 'mdw';
export const EXTENSION_FORMAT_ODT: string = 'odt';
export const EXTENSION_FORMAT_ODS: string = 'ods';
export const EXTENSION_FORMAT_ODP: string = 'odp';
export const EXTENSION_FORMAT_THMX: string = 'thmx';
export const EXTENSION_FORMAT_CALCX: string = 'calcx';
export const EXTENSION_FORMAT_MPP: string = 'mpp';
export const EXTENSION_FORMAT_PBIX: string = 'pbix';
export const EXTENSION_FORMAT_PBIT: string = 'pbit';
export const EXTENSION_FORMAT_WRI: string = 'wri';
export const EXTENSION_FORMAT_WPS: string = 'wps';
export const EXTENSION_FORMAT_XPS: string = 'xps';
export const EXTENSION_FORMAT_DBF: string = 'dbf';
export const EXTENSION_FORMAT_DIF: string = 'dif';
export const EXTENSION_FORMAT_SLK: string = 'slk';
export const EXTENSION_FORMAT_7Z: string = '7z';
export const EXTENSION_FORMAT_ZIP: string = 'zip';
export const EXTENSION_FORMAT_TAR: string = 'tar';
export const EXTENSION_FORMAT_RAR: string = 'rar';
export const EXTENSION_FORMAT_BZ: string = 'bz';
export const EXTENSION_FORMAT_BZ2: string = 'bz2';
export const EXTENSION_FORMAT_ARC: string = 'arc';
